import PathPlanFallDownRight from "../plan/PathPlanFallDownRight";
import PathPlanFallDownLeft from "../plan/PathPlanFallDownLeft";
import PathTemplatePattern from "./PathTemplatePattern";
import Path from "../Path";

// PATTERN VALUES:
// S start
// P path
// E end
// X closed
// O open
// 8 open or path
// . ignore

export default class PatternFallDown2Side1 extends PathTemplatePattern {
    constructor() {
        super([
            'S8',        // start   o|p
            'X8',        // closed  o|p
            '.E'         // ignore  end
        ],
        true);  // true to flip left/right
    }

    /**
     * Returns the minimum number of path steps required by this pattern to be applied.
     * @override
     * @returns {number}
     */    
    getMinRequiredPathSteps() {
        return 3;
    }
    
    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlan(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol() + 1;  // end tile is 1 column to the right of start
        const targetRow = start.getTileRow() + 2;  // end tile is 2 rows below start

        const endIndex = this.findTilePathIndex(path, pathIndex + 3, targetCol, targetRow);  // +3: we know the end is at least 3 steps away in the path.
        if (endIndex < 0) {
            return null;
        }
        
        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;
        return new PathPlanFallDownRight(start, end, steps);
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlanFlipped(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol() - 1;  // end tile is 1 column to the left of start
        const targetRow = start.getTileRow() + 2;  // end tile is 2 rows below start

        const endIndex = this.findTilePathIndex(path, pathIndex + 3, targetCol, targetRow);  // +3: we know the end is at least 3 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;
        return new PathPlanFallDownLeft(start, end, steps);
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'PatternFallDown2Side1';
    }
}